// Inline status badge used by document rows + Case rows + verdicts.
// Centralised so visual conventions don't drift between views.

import type { VerdictKind } from "../lib/types";

export function DocumentStatusBadge({ status }: { status: string }): JSX.Element {
  if (status === "complete") return <span className="badge-green">complete</span>;
  if (status === "failed") return <span className="badge-red">failed</span>;
  if (status === "uploaded") return <span className="badge-blue">queued</span>;
  return <span className="badge-yellow">{status}</span>;
}

export function VerdictBadge({ verdict }: { verdict: VerdictKind }): JSX.Element {
  if (verdict === "supported") return <span className="badge-green">supported</span>;
  if (verdict === "contradicted") return <span className="badge-red">contradicted</span>;
  return <span className="badge-gray">not addressed</span>;
}

export function CrossCheckableBadge({ cross_checkable }: { cross_checkable: boolean }): JSX.Element {
  if (cross_checkable) return <span className="badge-blue">cross-checkable</span>;
  return <span className="badge-gray">record</span>;
}
